import Backbone from 'backbone'
import DisplayHeader from 'scoreboard/components/display-header'
import FileDropOverlay from 'scoreboard/components/files/file-drop-overlay'
import i18n from 'scoreboard/components/i18n'
import permissions from 'scoreboard/components/permissions'
import NoObject from 'scoreboard/components/no-object'

const NoDocumentsView = Backbone.View.extend({

	className: 'display-layout empty-state no-documents-view',

	render: function() {
		let header = new DisplayHeader()
		this.$el.html(header.el)
		header.render()

		Backbone.trigger('pageTitle', i18n.get('documents.files'))

		if (permissions.isStrictViewer() || !permissions.documents()) {
			new NoObject({section: 'files', el: this.el}).render()
		} else {
			this.$el.append('<div class="display-pane-body"></div>')
			let message = i18n.get('documents.upload.drop.document.1') + ' ' +
				i18n.get('documents.upload.drop.document.2')
			let fileDropOverlay = new FileDropOverlay({
				visible: true,
				clickable: true,
				message
			})
			this.$('.display-pane-body').append(fileDropOverlay.el)
			fileDropOverlay.render()
				.on('drop', e => this.trigger('done', e))
				.on('click', () => this.trigger('click'))
		}

		return this
	}
})

export default NoDocumentsView

NoDocumentsView.__filename__ = 'documents/no-documents-view.js'
